import { useState } from "react";
import { Link } from "react-router-dom";
import type { MediaItem } from "@/types/media";
import { buildEpisodeGroups } from "@/utils/media";

export default function EpisodeList({ item, activeEpisode }: { item: MediaItem; activeEpisode?: number }) {
  const groups = buildEpisodeGroups(item);
  const [groupIndex, setGroupIndex] = useState(0);

  if (groups.length === 0) return null;
  const current = groups[Math.min(groupIndex, groups.length - 1)];

  return (
    <div>
      {groups.length > 1 && (
        <div className="flex items-center gap-1 p-1 rounded-full bg-background-200/60 border border-background-200 mb-4 w-fit max-w-full overflow-x-auto no-scrollbar">
          {groups.map((group, index) => (
            <button
              key={group.name}
              type="button"
              onClick={() => setGroupIndex(index)}
              className={`px-4 py-1.5 rounded-full text-xs whitespace-nowrap transition-colors cursor-pointer ${
                index === groupIndex ? "bg-primary-500 text-background-50 font-medium" : "text-foreground-700 hover:text-foreground-950"
              }`}
            >
              {group.name}
            </button>
          ))}
        </div>
      )}

      <div className="grid grid-cols-5 sm:grid-cols-6 gap-2 max-h-[320px] overflow-y-auto pr-1">
        {current.episodes.map((episode) => {
          const active = activeEpisode === episode;
          return (
            <Link
              key={episode}
              to={`/play/${item.id}/${episode}`}
              className={`h-10 rounded-md flex items-center justify-center text-sm font-label transition-colors cursor-pointer border ${
                active
                  ? "bg-primary-500 border-primary-500 text-background-50 font-semibold"
                  : "bg-background-200/60 border-background-200 text-foreground-700 hover:border-primary-400 hover:text-foreground-950"
              }`}
            >
              {episode}
            </Link>
          );
        })}
      </div>
    </div>
  );
}